import { requiredString } from "components/form/utils";
import { z } from "zod";

export const pullRequestSchema = z.object({
  url: z.string().url("Please enter a valid URL").min(1, "URL is required"),
  status: z.enum(["pending","open", "merged", "closed"]).optional(),
  action: z.enum(["merge", "close"]).optional(),
});
